import { useEffect, useState } from "react";
import styles from "./ResetPwModal.module.css";
import axios from "axios";
import { DEV_API } from "../Common/Constant";
import { useNavigate, useParams } from "react-router-dom";
import PasswordInput from "../CustomComp/pswdInput/PasswordInput";

const ResetPWModal = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [loginErr, updateLoginError] = useState("");
  const [successRes, updateSuccessRes] = useState("");
  const [counter, setCounter] = useState(5);
  const [formData, setFormData] = useState({
    password: "",
    repassword: "",
  });

  useEffect(() => {
    if (successRes) {
      if (counter > 0) {
        setTimeout(() => {
          setCounter((prevCount) => prevCount - 1);
        }, 1000);
      } else {
        navigate("/");
      }
    }
  }, [successRes, counter]);

  const onFormSubmit = (e) => {
    e.preventDefault();
    if (formData.repassword != formData.password) {
      updateLoginError("Password Mismatch");
    } else {
      axios
        .post(`${DEV_API}/users/reset-password/${params.token}`, {
          password: formData.password,
        })
        .then((res) => {
          updateSuccessRes("Password updated successfully");
        })
        .catch((err) => {
          console.error("err----", err?.response?.data?.error);
          updateLoginError(err?.response?.data?.error);
        });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const navToHomePage = () => {
    navigate("/");
  };

  return (
    <>
      <div className={styles.overlay}>
        <div className={styles.modal}>
          {(successRes && (
            <>
              <h3>{successRes}</h3>
              <h2>Redirecting in .... {counter}</h2>
              <button
                className={`${styles.secondaryBtn} ${styles.btn}`}
                onClick={navToHomePage}
              >
                Redirect Now
              </button>
            </>
          )) || (
            <>
              <h2 className="m0">Forgot Password</h2>
              <form
                id="forgotPwForm"
                onSubmit={onFormSubmit}
                className={styles.form}
              >
                <div className={styles.formGroup}>
                  <label>New Password</label>
                  <PasswordInput
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                  />
                </div>
                <div className={styles.formGroup}>
                  <label>Re-Enter Password</label>
                  <PasswordInput
                    name="repassword"
                    value={formData.repassword}
                    onChange={handleChange}
                  />
                </div>
                {successRes && (
                  <div className={styles.successRes}>{successRes}</div>
                )}
                {loginErr && (
                  <div className={styles.loginError}>{loginErr}</div>
                )}
              </form>

              <div className={styles.footer}>
                <button
                  form="forgotPwForm"
                  type="submit"
                  className={`${styles.submitButton} ${styles.btn}`}
                >
                  Submit
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ResetPWModal;
